
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import IconButton from "./IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";
import { PanelContext } from "@/components/Builder/SidebarPanels.vue";
import Dialog from "@/components/UI/Dialog.vue";

@Component({
  components: {
    Dialog,
    Icon,
    Dropdown,
    IconButton
  }
})
export default class Popout extends Vue {
  open = false;

  @Prop()
  title!: string;

  @Inject({ from: "panelContext", default: undefined })
  readonly panelContext?: PanelContext;
}
